import { AxiosResponse } from 'axios';

import { IErrorResponse, ISuccessResponse } from './responseHandler.types';

export function applySuccessResponseHandler(
  res: AxiosResponse
): ISuccessResponse {
  const { config, data, headers, status } = res;
  return {
    status,
    statusText: data?.status ?? null,
    data: data?.data ?? null,
    message: data?.msg ?? '',
    _$: res,
    config,
    headers,
  };
}

export function applyErrorResponseHandler(error: any): IErrorResponse {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const { data, status } = error.response as AxiosResponse;
    return {
      status: status,
      statusText: data?.status ?? null,
      data: data?.data ?? null,
      message: data?.msg ?? '',
      _$: error,
    };
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.error(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error('Error', error.message);
  }
  return {
    status: null,
    statusText: 'Failed',
    data: null,
    message: error?.message || 'Request failed to hit the server',
    _$: error,
  };
}
